import { Upload_Photo } from "./Upload_Photo";
import { Upload_Photo_Consultant } from "./Upload_Photo_Consultant";
// Delete this?
export function handlePhotoSubmit(
  e,
  base64,
  Photo_Type,
  Photo_Group,
  Attendee_ID,
  setState,
  User
) {
  e.preventDefault();
  if (User === "Student") {
    Upload_Photo(base64, Photo_Type, Photo_Group, Attendee_ID, setState);
  } else {
    Upload_Photo_Consultant(
      base64,
      Photo_Type,
      Photo_Group,
      Attendee_ID,
      setState
    );
  }
}
